import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useContext, useEffect, useState } from "react";
import {
  Autocomplete,
  TextField,
  Paper,
  Typography,
  Divider,
  IconButton,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

import DaignosisTable from "./DiagnosisTable";
import EmrDetails from "./EmrDetails";
import { useMutation } from "react-query";
import {
  ContextType,
  verificationContext,
} from "../context/VerificationContext";

import PageLoadSkeleton from "../../../utilis/component/SkeletonLoading/PageLoadSkeleton";
import { getallStatus, getComPlaints, UpdateClaimStatus } from "../../services";
import ErrorIcon from "@mui/icons-material/Error";
import PatientComplaints from "../../../EMR/components/Complaints";
import EditNoteIcon from "@mui/icons-material/EditNote";
import usePopup from "../../../hooks/usePopup";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { clinicId } from "../../../constants";
import Activity from "./Activity";
import PhysicalExamination from "../../../EMR/components/PhysicalExamination";
import moduleRoutes from "../../../routes/moduleRouteList";
import insuranceRouteList from "../../routeList";
const baseNavigationUrl = (window as any)._env_?.BASE_URL;
import UploadDocuments from "../../../EMR/components/UploadDocuments";
import { getvitalsById } from "../../../PatientCare/Nursing/vitals/service";
import { FormOnChangeEventType } from "../../../EMR/types";
import useAuthentication from "@hooks/useAuthentication";

let statusList: any;
function Tabcomponent() {
  type VitalsType = {
    vitalId: number; // Changed 'id' to 'vitalId' as per the data
    systolicBP: number;
    diastolicBP: number;
    respiratory: number;
    heartRate: number;
    headCircumference: number;
    bmi: number;
    sugar: number;
    bsa: number;
    weight: number;
    spo2: number;
    height: number;
    temperature: number;
    pulse: number;
    painscale: number;
    bloodGroup: { id: number; name: string };
    allergic: boolean | null;
    allergicnotes: string | null;
    immunisationHistory: string;
    createdDate: string;
    clinicianId: number | null;
    userName: string | null;
  };

  const [value, setValue] = useState("1");
  const [vitals, setVitals] = useState<VitalsType | null>(null);
  const [complaints, setCompliants] = useState<any>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [vitalOpen, setVitalOpen] = useState<boolean>(false);
  const [RosOpen, setRosOpen] = useState<boolean>(false);
  const { CustomModal } = usePopup();
  const { encounterId } = useParams();
  const [selectedValue, setSelectedValue] = useState<string | null>("1");
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [comment, setComment] = useState<string>("");
  const [error, setError] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const {user} = useAuthentication();
  const navigate = useNavigate();
  const {
    setView,
    searchData,
    loading,
    setloading,
    isDenial,
    patientIdDetails,
  } = useContext(verificationContext) as ContextType;
  const { mutate: getVitals, isLoading } = useMutation(getvitalsById, {
    onSuccess: (data) => {
      data && setVitals(data[0]);
    },
  });
  const { mutate: getcomplaints } = useMutation(getComPlaints, {
    onSuccess: (data) => {
      setCompliants(data.response);
    },
  });

  const { mutate: getAllStatus } = useMutation(getallStatus, {
    onSuccess: (data: any) => {
      statusList = data.response;
    },
  });
  const { mutate: updateClaim } = useMutation(UpdateClaimStatus, {
    onSuccess: () => {
      navigateBack();
    },
  });
  const handleChange = (_: any, newValue: string) => {
    setValue(newValue);
  };
  const ChangeVerificationStatus = (option: any) => {
    if (isDenial && comment == "") {
      setError(true);
      setSelectedStatus(null);
      return;
    } else {
      setError(false);
    }
    if (option) {
      updateClaim({
        encounterIds: [encounterId],
        verificationStatus: option.id,
        clinicId: clinicId,
        createdById: Number(user?.userId),
        subType: isDenial ? selectedValue : 0,
        comment: isDenial ? comment : "",
      });
    }
  };
  const navigateBack = () => {
    setView(true);
    navigate(
      `${baseNavigationUrl}${moduleRoutes.mainRoute}/${moduleRoutes.insurance}/${insuranceRouteList.Verification}`,
      {
        replace: true,
      }
    );
  };
  const closeComplaints = () => {
    getcomplaints(searchData?.encounter?.encounterId as number);
    setOpen(false);
  };
  useEffect(() => {
    setloading((prev) => ({
      ...prev,
      TabLoading: isLoading,
    }));
    getAllStatus();
  }, []);

  const isPriorApproval = location.pathname.includes(
    insuranceRouteList.priorApprovalPatientEdit
  );
  useEffect(() => {
    if (searchData?.encounter?.encounterId) {
      getVitals(searchData?.encounter?.encounterId as number);
      getcomplaints(searchData?.encounter?.encounterId as number);
      console.log();
    }
  }, [searchData?.encounter?.encounterId as number]);

  useEffect(() => {
    setSelectedStatus(JSON.parse(searchParams.get("status") as string));
  }, [searchParams]);
  return (
    <div className="h-fit">
      {loading.Tabloading ? (
        <PageLoadSkeleton />
      ) : (
        <TabContext value={value}>
          <Paper className="mx-2 my-2 grid grid-cols-12 pt-1">
            <div className="col-span-3">
              <TabList
                variant="fullWidth"
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Details" value="1" />
                <Tab label="EMR" value="2" />
                <Tab label="Upload Documents" value="3" />
              </TabList>
            </div>
            <div className="col-span-2 mt-1">
              {!isPriorApproval && (
                <Autocomplete
                  className="!mx-4 mt-1 h-8 "
                  disablePortal
                  options={statusList || []}
                  onChange={(_, option) => {
                    ChangeVerificationStatus(option);
                  }}
                  getOptionLabel={(option: any) =>
                    option?.verificationStatus || ""
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={selectedStatus}
                  renderInput={(params) => (
                    <TextField {...params} label="Status" />
                  )}
                />
              )}
            </div>
            <div className="col-span-1 ">
              <Button
                className="!mt-3 w-24 h-8"
                onClick={() => {
                  setVitalOpen(true);
                }}
              >
                {" "}
                View Vitals
              </Button>
            </div>
            <div className="col-span-1 ">
              <Button
                className="!mt-3 w-24 h-8"
                onClick={() => {
                  setRosOpen(true);
                }}
              >
                ROS
              </Button>
            </div>
            {isDenial && !patientIdDetails && (
              <>
                <FormControl className="col-span-3">
                  <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    defaultValue="1"
                  >
                    <FormControlLabel
                      onChange={() => {
                        setSelectedValue("1");
                      }}
                      value="1"
                      control={<Radio />}
                      label="Correction"
                    />
                    <FormControlLabel
                      onChange={() => {
                        setSelectedValue("2");
                      }}
                      value="2"
                      control={<Radio />}
                      label="Internal complaints"
                    />
                  </RadioGroup>
                </FormControl>
                <div className="col-span-2 flex justify-start items-center mr-4">
                  <TextField
                    onChange={(e: FormOnChangeEventType) => {
                      setComment(e.target.value);
                    }}
                    id="outlined-basic"
                    label="comment"
                    variant="outlined"
                    error={error} // MUI error styling
                    helperText={error ? "Comment is required" : ""}
                  />
                </div>
              </>
            )}
          </Paper>
          <TabPanel
            sx={{ padding: 0 }}
            value="1"
            className="h-fit overflow-y-auto"
          >
            <div className="grid grid-cols-12 gap-x-2 p-2">
              <div className="col-span-12 grid grid-cols-12  gap-2   py-2 ">
                <Paper className="col-span-12 2xl:col-span-12 my-1 ">
                  <Activity />
                </Paper>

                <Paper className="col-span-6 2xl:col-span-6 border border-r-slate-200 ">
                  <DaignosisTable />
                </Paper>
                <Paper className="col-span-6 border border-r-slate-200">
                  <div className="mx-2 my-1 flex justify-between items-center">
                    <strong>Complaints</strong>
                    <div className="mr-10">
                      <IconButton
                        onClick={() => {
                          setOpen(true);
                        }}
                        edge="end"
                        aria-label="delete"
                      >
                        <EditNoteIcon color="primary" />
                      </IconButton>
                    </div>
                  </div>
                  <Divider />
                  <div className="grid grid-cols-12 items-center justify-center ms-3 p-3 gap-y-4">
                    {complaints && complaints.length > 0 ? (
                      complaints.map((item: any, index: number) => {
                        return (
                          <div
                            key={index}
                            className="col-span-12 md:col-span-4 flex justify-center"
                          >
                            <div
                              className="flex items-center justify-between  p-3  shadow-md w-full"
                              style={{ maxWidth: "300px" }}
                            >
                              <Typography
                                variant="body1"
                                className="font-semibold "
                              >{` ${item?.complaints?.comName}`}</Typography>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-span-12 flex justify-center items-center flex-col gap-2">
                        <ErrorIcon color="info" sx={{ fontSize: "2rem" }} />
                        No complaints found
                      </div>
                    )}
                  </div>
                </Paper>
              </div>
              <CustomModal
                title="complants"
                open={open}
                setOpen={setOpen}
                handleClose={() => {
                  closeComplaints();
                }}
              >
                <div className="w-[50vw] ">
                  <PatientComplaints />
                </div>
              </CustomModal>
            </div>
          </TabPanel>
          <TabPanel className="h-fit " value="2">
            <EmrDetails />
          </TabPanel>
          <TabPanel value="3" className="h-fit ">
            <UploadDocuments files=".pdf" submission={true} />
          </TabPanel>

          <CustomModal title="vitals" open={vitalOpen} setOpen={setVitalOpen}>
            <Paper variant="elevation" className="w-[50vw] col-span-12 p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4 mt-4">
                {vitals ? (
                  [
                    { label: "Height (cm)", value: vitals.height },
                    { label: "Weight (kg)", value: vitals.weight },
                    { label: "BMI (kg/m²)", value: vitals.bmi },
                    {
                      label: "Is allergic",
                      value: String(vitals.allergic || ""),
                    },
                    { label: "Pain scale (NRS)", value: vitals.painscale },
                    { label: "Temperature (°C)", value: vitals.temperature },
                    { label: "Systolic BP (mm Hg)", value: vitals.systolicBP },
                    {
                      label: "Diastolic BP (mm Hg)",
                      value: vitals.diastolicBP,
                    },
                    { label: "Sugar (mg/dL)", value: vitals.sugar },
                    {
                      label: "Head circumference (cm)",
                      value: vitals.headCircumference,
                    },
                    { label: "Heart rate (bpm)", value: vitals.heartRate },
                    { label: "Pulse (bpm)", value: vitals.pulse },
                    {
                      label: "Respiratory rate (breaths/min)",
                      value: vitals.respiratory,
                    },
                    { label: "SpO₂ (%)", value: vitals.spo2 },
                    { label: "Blood group", value: vitals.bloodGroup?.name },
                    { label: "BSA (m²)", value: vitals.bsa },
                    {
                      label: "Immunisation history",
                      value: vitals.immunisationHistory,
                    },
                  ].map((vital, index) => (
                    <div className="flex justify-between" key={index}>
                      <Typography
                        variant="body1"
                        className="font-semibold text-md"
                      >
                        {vital.label}:
                      </Typography>
                      <Typography variant="body1" className="text-md">
                        {vital.value}
                      </Typography>
                    </div>
                  ))
                ) : (
                  <div className="col-span-12 flex justify-center items-center flex-col gap-2">
                    <ErrorIcon color="info" sx={{ fontSize: "2rem" }} />
                    <Typography>No Vitals found</Typography>
                  </div>
                )}
              </div>
            </Paper>
          </CustomModal>
          <CustomModal title="ROS" open={RosOpen} setOpen={setRosOpen}>
            <div className="w-[50vw] grid-cols-12 max-h-[90dvh] overflow-y-auto">
              <PhysicalExamination component="ROS" />
            </div>
          </CustomModal>
        </TabContext>
      )}
    </div>
  );
}

export default Tabcomponent;
